module.exports = __webpack_public_path__ + "img/login-serve.73a29df.png";